/**
 * Roles that carry PHARMACIST authority in the UI.
 *
 * Client-side twin of the backend's `CLINICAL_SIGNING_ROLES`
 * (`backend-v2/src/user-management/enums/custom-role.enum.ts`), which is what
 * the write paths actually enforce — this list only decides what the UI OFFERS.
 * Change one and you must change the other, or users get controls the server
 * 403s.
 *
 * Used by:
 *  - Clinical Verification signing (pharmacist-only signature type)
 *  - GP-1380 Swap RX Numbers: overriding a failed clinical-equivalence check
 */
export const PHARMACIST_ROLES: readonly string[] = [
  'pharmacy_admin',
  'clinical_pharmacist',
  'wally_dev_admin',
];

/** True when the signed-in user's custom role carries pharmacist authority. */
export const isPharmacistRole = (customRole?: string | null): boolean =>
  !!customRole && PHARMACIST_ROLES.includes(customRole);
